import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSpring, animated } from 'react-spring';
import { playSound } from '../../HOME/utils';
import * as f from '../logic';
import { UNSELECT_TILE, REPORT_INVALID_ACTION, SET_STARTED_TRUE } from '../REDUX/actions';
import { MODE_SOLO, MODE_AI } from '../../HOME/const';

const Spot = ({ spot }) => {
  const dispatch = useDispatch();
  const { pn, common } = useSelector(state => state);

  const handleSpotClick = spot => {
    if (!pn.selected || (pn.mode === MODE_AI && pn.turn === 2)) {
      return;
    }

    playSound(common, 'click');

    if (spot.invalid) {
      playSound(common, 'drop');
      dispatch({ type: REPORT_INVALID_ACTION, message: spot.invalid });
      return;
    }

    const tile = pn.selected;
    dispatch(UNSELECT_TILE);
    tile.spot = spot;

    if (pn.mode !== MODE_SOLO && !pn.started) {
      dispatch(SET_STARTED_TRUE);
    }
  };

  const { opacity } = useSpring({
    opacity: spot.invalid ? 0 : 1,
  });

  const { row, col } = spot;
  const gridArea = `${row}/${col}`;
  return <animated.div id={spot.id} className="pn-spot" style={{ gridArea, opacity }} onClick={() => handleSpotClick(spot)} />;
};

export default Spot;
